<nav class="onboarding-banner">
  @if (showTeamName) {
    <b>{{ this.teamName }}</b>
  }

  <div
    class="onboarding-banner__free-trial-text"
    [ngbTooltip]="freeTrialCutoffDateMessage"
    container="body"
    placement="bottom"
  >
    {{ remainingTrialTimeMessage }}
  </div>

  <a
    class="btn btn-info text-white"
    [href]="REQUEST_TRIAL_EXTENSION_EMAIL"
    target="_blank"
  >
    <span class="onboarding-banner__emoji">⏳</span>
    <ng-container>&nbsp;</ng-container>
    <ng-container i18n>Request more time</ng-container>
  </a>

  <a class="btn btn-success text-white" routerLink="{{ SUBSCRIBE_NOW_LINK }}">
    <span class="onboarding-banner__emoji">❤️</span>
    <ng-container>&nbsp;</ng-container>
    <ng-container i18n>Subscribe now</ng-container>
  </a>

  <button class="btn btn-info text-white" (click)="toggleOnboardingVideo()">
    <span class="onboarding-banner__emoji">▶️</span>
    <ng-container>&nbsp;</ng-container>
    @if (isOnboardingVideoVisible()) {
      <ng-container i18n>Hide quick tutorial</ng-container>
    } @else {
      <ng-container i18n>Show quick tutorial</ng-container>
    }
  </button>

  <a
    class="btn btn-success text-white"
    [href]="BOOK_ONBOARDING_URL"
    target="_blank"
  >
    <span class="onboarding-banner__emoji">💬</span>
    <ng-container>&nbsp;</ng-container>
    <ng-container i18n>Book free Zoom help call</ng-container>
  </a>
</nav>
